module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-7bc9b32334bb252e242258b39ea4e24c.svg";